import { Button } from "@shadcn/ui/button";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Globe } from "lucide-react";
import { RiInstagramLine, RiTiktokFill } from "@remixicon/react";
import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { PageContainer } from "~/components/layout/PageContainer";
import { AppHeader } from "~/components/layout/AppHeader";

export const Route = createFileRoute("/$hubMetaName/raffle/$raffleId/thank-you")({
	beforeLoad: () => {
		document.title = 'bacehub | Startseite'
	},
	component: RouteComponent,
});

function RouteComponent() {
	const i18n = useI18nContext().LL["new-ui"];

	return (
		<PageContainer>
			<AppHeader service="RAFFLE" />
			<div className="flex flex-col h-full px-6">
				<div className="text-center py-8">
					<h1 className="text-2xl font-breit mb-3">
						<T>{i18n.RAFFLE_THANK_YOU_TITLE()}</T>
					</h1>
					<p className="text-sm text-muted-foreground">
						<T>{i18n.RAFFLE_FOLLOW_US()}</T>
					</p>
				</div>
				<div className="flex flex-col gap-4 mb-8">
					<Button variant="outline" className="w-full" asChild>
						<a href="https://www.tiktok.com/@bace.hub" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
							TikTok
							<RiTiktokFill className="h-4 w-4" />
						</a>
					</Button>
					<Button variant="outline" className="w-full" asChild>
						<a href="https://www.instagram.com/bace.hub" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
							Instagram
							<RiInstagramLine className="h-4 w-4" />
						</a>
					</Button>
					<Button variant="outline" className="w-full" asChild>
						<a href="https://bacehub.de/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
							bacehub.de
							<Globe className="h-4 w-4" />
						</a>
					</Button>
				</div>
				<div className="mt-auto pb-8">
					<Button className="w-full" size="lg" asChild>
						<Link to="/">
							<T>{i18n.GO_TO_HOMEPAGE()}</T>
						</Link>
					</Button>
				</div>
			</div>
		</PageContainer>
	);
}
